import useLazySelector from "common/redux/useLazySelector";
import { ContractColumnConfigurations, mobileColumns } from "./ContractListColumns";
import { loadContractColumnConfigurations } from "./contracts.actions";

export default function useContractColumns(useMobileColumns: boolean): ContractColumnConfigurations {
    const columns = useLazySelector(store => store.contractColumnConfigurations, loadContractColumnConfigurations)

    return useMobileColumns ? mobileColumns : columns;
}